import { THEMES, type Theme } from "@crc/shared";
import { useTheme } from "../../lib/theme.tsx";

export function ThemeSwitchInline() {
  const { theme, setTheme } = useTheme();
  const labels: Record<Theme, string> = { light: "Light", navy: "Navy", dark: "Dark", warm: "Warm" };
  return (
    <div className="theme-switch" role="group" aria-label="Theme">
      {THEMES.map((t) => (
        <button key={t} type="button" className={theme === t ? "active" : ""} onClick={() => setTheme(t)} aria-pressed={theme === t}>
          <span className={`dot dot-${t}`} />
          <span className="tlabel">{labels[t]}</span>
        </button>
      ))}
    </div>
  );
}
